import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import noop from "lodash/noop";
import { Transition } from "react-transition-group";
import { PANEL_SIZES, PANEL_VARIANTS } from "./Panel";
import { AnimatedPanelInner, AnimatedPanelOuter, getTransitionStyles, TRANSITION_TIME } from "./Animations.styled";
export const PanelAnimations = forwardRef((props, _ref) => {
    /* istanbul ignore next */
    const { direction, children, isOpen, onEnter, onEntered, onExit, onExited, size = "small", variant = "configuration", shouldRenderOffScreen } = props;
    const { isElevated } = PANEL_VARIANTS[variant];
    const dropShadowElevationPadding = isElevated ? 8 : 0;
    const panelWidth = `${PANEL_SIZES[size] + dropShadowElevationPadding * 2}px`;
    const nodeRef = React.useRef(null);
    return (_jsx(Transition, { in: isOpen, timeout: TRANSITION_TIME, appear: true, onEnter: onEnter, onEntered: onEntered, onExit: onExit, onExited: onExited, nodeRef: nodeRef, children: (transitionStatus) => (_jsx(AnimatedPanelOuter, { width: panelWidth, ref: nodeRef, children: _jsx(AnimatedPanelInner, { isOpen: isOpen, animationDirection: direction, dropShadowElevationPadding: dropShadowElevationPadding, isElevated: isElevated, time: TRANSITION_TIME, style: getTransitionStyles({ transitionStatus, direction }), children: (shouldRenderOffScreen || transitionStatus !== "exited") && children }) })) }));
});
PanelAnimations.defaultProps = {
    size: "small",
    isElevated: true,
    onEnter: noop,
    onEntered: noop,
    onExit: noop,
    onExited: noop,
    shouldRenderOffScreen: false
};
